export default __webpack_public_path__ + "static/unacarneasada-01ec27592ada6ffac1cdb1c912bdad12.jpg";